import { safetyWiseApi } from "utils/safetyWiseApi";

export const TIMESHEET_OVERLAP_WARNING_MESSAGE =
	"This overlaps with another timesheet.";

/**
 * Asks the API whether a proposed work timesheet overlaps another for the same person.
 * Offline (or a failed check) skips the warning so save can proceed as today.
 */
export async function checkTimesheetOverlap({
	organisationId,
	staffId,
	startDateTimeUTC,
	endDateTimeUTC,
	excludeTimesheetId,
	hasNetwork,
	post = safetyWiseApi.post,
} = {}) {
	if (!hasNetwork || !organisationId || !staffId || !startDateTimeUTC || !endDateTimeUTC) {
		return { hasOverlap: false, skipped: true };
	}

	try {
		const body = {
			staffId,
			startDateTimeUTC,
			endDateTimeUTC,
		};
		if (excludeTimesheetId) {
			body.excludeTimesheetId = excludeTimesheetId;
		}

		const response = await post(`${organisationId}/timesheet/check-overlap`, body);
		const hasOverlap = !!response?.data?.hasOverlap;
		return {
			hasOverlap,
			skipped: false,
			message: response?.data?.message || TIMESHEET_OVERLAP_WARNING_MESSAGE,
		};
	} catch (error) {
		return { hasOverlap: false, skipped: true, error: true };
	}
}

/** Build ISO start/end from form date + time fields (local wall clock). */
export const timesheetFormRangeToUtcIso = (timesheet, momentLib) => {
	if (!timesheet?.startDate || !timesheet?.startTime || !timesheet?.endDate || !timesheet?.endTime) {
		return null;
	}
	const start = momentLib(
		`${timesheet.startDate} ${timesheet.startTime}`,
		"YYYY-MM-DD HH:mm"
	);
	const end = momentLib(`${timesheet.endDate} ${timesheet.endTime}`, "YYYY-MM-DD HH:mm");
	if (!start.isValid() || !end.isValid()) {
		return null;
	}
	return {
		startDateTimeUTC: start.toISOString(),
		endDateTimeUTC: end.toISOString(),
	};
};
